module.exports = __webpack_public_path__ + "media/images/application/template/footer-logo-a874e37307b2a22c6687427d12a2274c.svg";